import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const SiteContext = createContext({ site: null, loading: true });

export const SiteProvider = ({ children }) => {
  const [site, setSite] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/public/site")
      .then((res) => setSite(res.data))
      .catch(() => setSite(null))
      .finally(() => setLoading(false));
  }, []);

  return <SiteContext.Provider value={{ site, loading }}>{children}</SiteContext.Provider>;
};

export const useSite = () => useContext(SiteContext);
